import { Component } from 'react';
import PropTypes from 'prop-types';
import PresentationRecord from '../records/PresentationRecord';
import LegalConsentRecord from '../records/LegalConsentRecord';
import PublicView from '../components/view/PublicView';
import { trackInteraction } from '../tracking/tracker';
import { DOCUMENT_VIEW } from '../tracking/actions';

// @ts-expect-error No types
import hubspotGTMContainer from '../utils/hubspotGTMContainer';
// @ts-expect-error No types
import isMobile from 'isMobile';
import ViewNotAvailable from '../components/view/ViewNotAvailable';
import ViewNotFound from '../components/view/ViewNotFound';
import ViewError from '../components/view/ViewError';
import NoPermissionError from '../components/view/NoPermissionError';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ViewContainer extends Component {
  componentDidMount() {
    hubspotGTMContainer();
    if (this.props.presentation) {
      trackInteraction(DOCUMENT_VIEW);
      this.props.fetchMeetingLink();
    }
    if (!isMobile.any) {
      // Load the chat widget as long as we aren't on mobile. Automatic loading
      // is disabled in a script tag in view.html.jade
      window.hsConversationsOnReady = [() => {
        window.HubSpotConversations.widget.load();
      }];
    }
  }
  render() {
    const {
      presentation,
      presentationNotFound,
      presentationNotAvailableEndDate,
      meetingLink,
      identifyViewer,
      finishActivity,
      fetchDownloadLink,
      noPermission,
      requiresViewerInfo,
      legalConsent
    } = this.props;
    if (presentationNotAvailableEndDate) {
      return /*#__PURE__*/_jsx(ViewNotAvailable, {
        endDate: presentationNotAvailableEndDate
      });
    }
    if (presentation === undefined) {
      if (presentationNotFound) {
        return /*#__PURE__*/_jsx(ViewNotFound, {});
      }
      if (noPermission) {
        return /*#__PURE__*/_jsx(NoPermissionError, {});
      }
      return /*#__PURE__*/_jsx(ViewError, {});
    }
    return /*#__PURE__*/_jsx(PublicView, {
      presentation: presentation,
      meetingLink: meetingLink,
      onIdentifyViewer: identifyViewer,
      onFinishActivity: finishActivity,
      fetchDownloadLink: fetchDownloadLink,
      requiresViewerInfo: requiresViewerInfo,
      legalConsent: legalConsent
    });
  }
}
ViewContainer.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord),
  presentationNotFound: PropTypes.bool,
  presentationNotAvailableEndDate: PropTypes.number,
  noPermission: PropTypes.bool,
  meetingLink: PropTypes.string,
  identifyViewer: PropTypes.func,
  finishActivity: PropTypes.func,
  fetchDownloadLink: PropTypes.func.isRequired,
  fetchMeetingLink: PropTypes.func.isRequired,
  requiresViewerInfo: PropTypes.bool,
  legalConsent: PropTypes.instanceOf(LegalConsentRecord)
};